import { AuthenticateWithRedirectCallback } from "@clerk/clerk-react";

const SSOCallback = () => {
    const afterAuth = sessionStorage.getItem("tlk_after_auth");
    const username = sessionStorage.getItem("redirectUsername") || "";
    const destination = afterAuth || `/user/creator-list?username=${username}`;

    return (
        <>
            <AuthenticateWithRedirectCallback
                afterSignInUrl={destination}
                afterSignUpUrl={destination}
            />
            <div className="magic-link-welcome" role="status" aria-live="polite">
                <div className="welcome-card">
                    <div className="spin-ring" aria-hidden="true">
                        <div className="ring" />
                    </div>
                    <p>Signing you in…</p>
                    <span className="welcome-hint">This will only take a moment.</span>
                </div>
            </div>
        </>
    );
};

export default SSOCallback;